import tieneDeuda from '../../controllers/tieneDeuda'
import { yaTieneSuscripcionDigital, suscripcionConBonificado, defaultCase } from "../../helpers/flow"

export const flowSuscriptor = (code, isPdf) => {
    switch (code) {
        case '07': //TIENE DEUDA
            console.log('Tiene Deuda');
            tieneDeuda();
            break;
        case '08': //YA TIENE SUSCRIPCION DIGITAL
        case '14': //Sin credenciales y con suscripcion digital
            yaTieneSuscripcionDigital(isPdf);
            break;
        case '25': //PREMIUM TITULAR
        case '26': //PREMIUM ADICIONAL
        case '28': //BLACK TITULAR
            suscripcionConBonificado();
            break;
        case '0001':
        default:
            defaultCase(code, isPdf);
            break;
    }
}


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/handlers/flow/flowSuscriptor.js